import ArchiveDesktopMain from "./desktop/ArchiveDesktopMain";
import MobileTransactionArchive from "./mobile/MobileTransactionArchive";
import MediaQuery from "react-responsive";
import React from "react";

export default function ArchiveContainer() {
    return (
        <MediaQuery maxWidth="599px">
            {(isMobile) => {
                return isMobile ? <MobileTransactionArchive /> : <ArchiveDesktopMain />;
            }}
        </MediaQuery>
    );
}
